const Level2 = ({
  currentImage,
  L0OuterL3,
  L0OuterL4,
  L0OuterL5,
  L0OuterL6,
  L2Business,
  L2Core,
  L2Leadership,
  L2Self,
}) => {
  return (
    <div className={`${currentImage !== "imagedivl2" ? "hidden" : ""}`}>
      <div className="" id="imagedivl2">
        <div>
          <img
            src="assets/images/outerL2 1.png"
            useMap="#lw02"
            className="w-80 h-80"
            alt=""
          />
          <map name="lw02" id="lw02">
            <area
              className="cursor-pointer"
              alt="L2 Outer L3"
              onClick={L0OuterL3}
              coords="1006,147,930,246,995,311,1041,384,1071,451,1094,536,1216,525,1210,468,1182,391,1141,305,1086,229"
              shape="poly"
            />
            <area
              className="cursor-pointer"
              alt="L2 Outer L4"
              onClick={L0OuterL4}
              coords="296,97,354,194,429,162,508,139,575,124,644,127,715,138,732,20,673,12,571,12,479,20,392,48"
              shape="poly"
            />
            <area
              className="cursor-pointer"
              alt="L2 Outer L5"
              onClick={L0OuterL5}
              coords="6,625,113,623,124,525,150,430,189,359,223,310,129,248,97,293,62,367,29,466,13,529"
              shape="poly"
            />
            <area
              className="cursor-pointer"
              alt="L2 Outer L6"
              onClick={L0OuterL6}
              coords="221,915,136,979,192,1047,254,1097,332,1147,437,1189,496,1202,520,1092,420,1062,353,1026,293,986"
              shape="poly"
            />
            <area
              className="cursor-pointer"
              alt="L2 Business"
              onClick={L2Business}
              coords="616,620,838,838,1053,617"
              shape="poly"
            />
            <area
              className="cursor-pointer"
              alt="L2 Self"
              onClick={L2Self}
              coords="613,1061,612,624,388,844,498,949"
              shape="poly"
            />
            <area
              className="cursor-pointer"
              alt="L2 Leadership "
              onClick={L2Leadership}
              coords="612,617,388,399,173,618"
              shape="poly"
            />
            <area
              className="cursor-pointer"
              alt="L2 Core"
              onClick={L2Core}
              coords="615,176,834,390,616,614"
              shape="poly"
            />
          </map>
        </div>
      </div>
    </div>
  );
};

export default Level2;
